/** Przechowuje pełną ścieżkę powrotu dla sesji B2B (pathname + search), aby przetrwała przejście przez bramkę płatności. */
export const B2B_HOME_PAGE_LOCAL_STORAGE_KEY = "eaktywni_b2bHomePage";

export function persistB2bHomePageUrl(pathnameAndSearch: string): void {
  try {
    localStorage.setItem(B2B_HOME_PAGE_LOCAL_STORAGE_KEY, pathnameAndSearch);
  } catch {
    // prywatne okno / quota — ignorujemy
  }
}

/** Usuwa zapis (np. przy wylogowaniu). */
export function clearB2bHomePageUrl(): void {
  try {
    localStorage.removeItem(B2B_HOME_PAGE_LOCAL_STORAGE_KEY);
  } catch {
    // ignorujemy
  }
}

/** Odczytuje i usuwa zapis — wywołaj przy jednorazowym powrocie (np. przycisk „zacznij od nowa”). */
export function getAndClearB2bHomePageUrl(): string | null {
  try {
    const value = localStorage.getItem(B2B_HOME_PAGE_LOCAL_STORAGE_KEY);
    if (value) {
      localStorage.removeItem(B2B_HOME_PAGE_LOCAL_STORAGE_KEY);
    }
    return value;
  } catch {
    return null;
  }
}
